import { CustomElement } from "../../../core/CustomElement";
import SelectManyVM from "./selectManyVm";
import SelectItem from "../../../core/interfaces/SelectItem";
import "../field/field";
import "../../icon/index";
import { CCCField } from "../field/field";

export class CCCSelectMany extends CustomElement {
  $cccField: CCCField;

  static get observedAttributes(): Array<string> {
    return [
      "disabled",
      "label",
      "label-edge",
      "label-width",
      "label-align",
      "min-length",
      "min-selected-items",
      "max-selected-items",
      "readonly",
      "disabled",
      "internal-loading",
      "message",
      "hide-icon",
    ];
  }

  constructor() {
    super();
    this.templateConfig = {
      template: require("./selectMany.html").default,
      style: require("./selectMany.scss").default,
      viewModel: require("./selectManyVm"),
    };
    this.setupComponent();
    this.$cccField = this.shadowDom.querySelector("ccc-field");
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: string | null,
    newValue: string | null
  ): void {
    if (attr === "label" && this.$cccField) {
      this.$cccField.label = newValue;
    }
    if (attr === "label-edge" && this.$cccField) {
      this.$cccField.setAttribute("label-edge", newValue);
    }
    if (attr === "label-width" && this.$cccField) {
      this.$cccField.setAttribute("label-width", newValue);
    }
    if (attr === "label-align" && this.$cccField) {
      this.$cccField.setAttribute("label-align", newValue);
    }
    if (attr === "min-length") {
      this.viewModel.minLength(newValue);
    }
    if (attr === "min-selected-items") {
      this.viewModel.minSelectedItems(newValue);
    }
    if (attr === "max-selected-items") {
      this.viewModel.maxSelectedItems(newValue);
    }
    if (attr === "readonly") {
      const $input = this.shadowDom.querySelector("input");
      if (newValue === null) {
        $input.removeAttribute("readonly");
      } else {
        $input.setAttribute("readonly", "");
      }
    }
    if (attr === "disabled") {
      const $input = this.shadowDom.querySelector("input");
      if (newValue === null) {
        $input.removeAttribute("disabled");
        if (this.$cccField) {
          this.$cccField.removeAttribute("disabled");
        }
      } else {
        $input.setAttribute("disabled", "");
        if (this.$cccField) {
          this.$cccField.setAttribute("disabled", "");
        }
      }
    }
    if (attr === "internal-loading" && this.$cccField) {
      if (newValue === null) {
        this.$cccField.removeAttribute("internal-loading");
      } else {
        this.$cccField.setAttribute("internal-loading", newValue);
      }
    }
    if (attr === "message" && this.$cccField) {
      if (newValue === null) {
        this.$cccField.removeAttribute("message");
      } else {
        this.$cccField.setAttribute("message", newValue);
      }
    }
    if (attr === "hide-icon") {
      const $icon = this.shadowDom.querySelector(".icon-container");
      if ($icon) {
        if (newValue === null) {
          $icon.classList.remove("hidden");
        } else {
          $icon.classList.add("hidden");
        }
      }
    }
  }

  watchOptions(): void {
    this.viewModel.options(this.state.options);
  }

  public onValueChange(
    callback: ((viewModel: SelectManyVM, val: SelectItem[]) => void) | null,
    timeout: number | null = null
  ): void {
    this.viewModel.onValueChange(callback, timeout);
  }

  public onRawValueChange(
    callback: ((viewModel: SelectManyVM, val: string) => void) | null,
    timeout: number | null = null
  ): void {
    this.viewModel.onRawValueChange(callback, timeout);
  }

  public onFocusChange(
    callback: ((viewModel: SelectManyVM, val: boolean) => void) | null
  ): void {
    this.viewModel.onFocusChange(callback);
  }

  public onAddItem(callback: (itemToAdd: SelectItem) => void): void {
    this.viewModel.onAddItem = callback;
  }

  public onRemoveItem(callback: (itemToRemove: SelectItem) => void): void {
    this.viewModel.onRemoveItem = callback;
  }

  public addItem(itemToAdd: SelectItem): void {
    this.viewModel.addItem(itemToAdd);
  }

  public removeItem(itemToRemove: SelectItem): void {
    this.viewModel.removeItem(itemToRemove);
  }

  public getValue(): Array<SelectItem> {
    return this.viewModel.value();
  }

  public setValue(value: SelectItem[]): void {
    this.viewModel.value(value);
  }

  public resetValue(): void {
    return this.viewModel.value([]);
  }

  public setLoading(loading: boolean): void {
    this.viewModel.displayLoader(loading);
    this.viewModel.disabled(loading);
  }

  public getOptions(): SelectItem[] {
    return this.viewModel.options();
  }
}

// define component
if (!customElements.get("ccc-select-many")) {
  customElements.define("ccc-select-many", CCCSelectMany);
}
